import { render, staticRenderFns } from "./VesselGeneralInfo.vue?vue&type=template&id=da8bd45a&scoped=true&"
import script from "./VesselGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./VesselGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./VesselGeneralInfo.vue?vue&type=style&index=0&id=da8bd45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8bd45a",
  null
  
)

export default component.exports